import React, { lazy, Suspense } from 'react';
import Loader from '../../../components/Loader/Loader.lazy';

const LazyEditUserProfile = lazy(() => import('./EditUserProfile'));

const EditUserProfile = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyEditUserProfile {...props} />
  </Suspense>
);

export default EditUserProfile;
